import { Card, Divider, Stack, TextField, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import TextButton from '../../actions/TextButton';
import useOrder from '../../../hooks/api/useOrder';
import { useSnackbar } from 'notistack';

const OrderNotes = ({
    order
}) => {

    const orderManager = useOrder()
    const { enqueueSnackbar } = useSnackbar();

    const [notes, setNotes] = useState("")
    const [sending, setSending] = useState(false)

    useEffect(() => {
        if(order){
            setNotes(order?.note)
        }
    }, [order])

    const onChange = useCallback((e) => {
        setNotes(e.target.value)
    }, [])

    const onSubmit = useCallback(async() => {
        setSending(true)    

        let _data = notes === "" ? "@null!!" : notes
        let data2send = {
            note:_data
        }

        try {
            await orderManager.actions.onEdit(order?.id_order, order?.user_id, data2send)
        } catch (error) {
            console.log(error)
            enqueueSnackbar(error?.message, {variant:'error'})
            return
        }
        enqueueSnackbar("Orden actualizada", {variant:'success'})
        setSending(false)
    }, [notes])

    return ( 
        <Card sx={{px:2, py:2}}>
            <Typography variant='subtitle1' sx={{mb:1}}>Notas</Typography>
            <Stack spacing={1}>
                <TextField 
                    value={notes}
                    multiline
                    rows={5}
                    fullWidth
                    placeholder='Escriba las notas de la orden'
                    onChange={onChange}
                
                />
                <Stack alignItems='flex-end'>
                    <TextButton size='small' onClick={onSubmit}>
                        Guardar
                    </TextButton>
                </Stack>
            </Stack>
            

        </Card>
     );
}
 
export default OrderNotes;